import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import React from "react";
import style from "./YearMenu.module.scss";
import { useRouterContext } from "../../../../context/RouterContext";
import { CustomLink } from "../../../shared/components/CustomLink/CustomLink";
const DonationYearMenu: React.FC<{
  totalTitle: string;
  years: number[];
  selected: string;
  mobile?: boolean;
}> = t0 => {
  const $ = _c(31);
  let {
    totalTitle,
    years,
    selected,
    mobile
  } = t0;
  const {
    dashboardPath,
    donationsPagePath
  } = useRouterContext();
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== dashboardPath || $[1] !== donationsPagePath || $[2] !== mobile || $[3] !== selected || $[4] !== totalTitle || $[5] !== years) {
    years = years.sort(_temp);
    t3 = `${style.menu} ${mobile ? style.menumobile : ""}`;
    t4 = mobile ? "" : "year-menu";
    const t5 = selected == "total" ? style["menu-selected"] : "";
    let t6;
    if ($[11] !== dashboardPath) {
      t6 = dashboardPath.join("/");
      $[11] = dashboardPath;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== totalTitle) {
      t7 = <span>{totalTitle}</span>;
      $[13] = totalTitle;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t6 || $[16] !== t7) {
      t8 = <CustomLink href={t6} scroll={false} onClick={_temp4}>{t7}</CustomLink>;
      $[15] = t6;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    if ($[18] !== t5 || $[19] !== t8) {
      t1 = <li className={t5} onMouseDown={_temp2} onMouseUp={_temp3}>{t8}</li>;
      $[18] = t5;
      $[19] = t8;
      $[20] = t1;
    } else {
      t1 = $[20];
    }
    let t9;
    if ($[21] !== donationsPagePath || $[22] !== selected) {
      t9 = year => <li key={year} className={selected == year.toString() ? style["menu-selected"] : ""} onMouseDown={_temp5} onMouseUp={_temp6}><CustomLink href={{
          pathname: [...donationsPagePath, year].join("/")
        }} scroll={false} onClick={_temp7}><span>{year}</span></CustomLink></li>;
      $[21] = donationsPagePath;
      $[22] = selected;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    t2 = years.map(t9);
    $[0] = dashboardPath;
    $[1] = donationsPagePath;
    $[2] = mobile;
    $[3] = selected;
    $[4] = totalTitle;
    $[5] = years;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = years;
  } else {
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    years = $[10];
  }
  let t5;
  if ($[24] !== t1 || $[25] !== t2) {
    t5 = <ul>{t1}{t2}</ul>;
    $[24] = t1;
    $[25] = t2;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== t3 || $[28] !== t4 || $[29] !== t5) {
    t6 = <div className={t3} data-cy={t4}>{t5}</div>;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  return t6;
};
export default DonationYearMenu;
function _temp(a, b) {
  return b - a;
}
function _temp2(e) {
  return e.currentTarget.style.outline = "none";
}
function _temp3(e_0) {
  return e_0.currentTarget.removeAttribute("style");
}
function _temp4(e_1) {
  return e_1.currentTarget.blur();
}
function _temp5(e_2) {
  return e_2.currentTarget.style.outline = "none";
}
function _temp6(e_3) {
  return e_3.currentTarget.removeAttribute("style");
}
function _temp7(e_4) {
  return e_4.currentTarget.blur();
}